!(function () {
    "use strict";

    class t extends HTMLElement {
        constructor() {
            super(),
                (this.boundHandleClick = this.handleClick.bind(this)),
                (this.boundResetATC = this.resetATC.bind(this)),
                (this.boundOptionChange = this.handleOptionChange.bind(this)),
                (this.boundScroll = this.toggleScroll.bind(this));
        }

        connectedCallback() {
            (this.section = this.closest("product-info")),
                (this.form = this.section?.querySelector("[data-product-form]"));

            if (!this.section || !this.form) return;

            (this.formWrapper =
                (window.theme?.settings?.productPageSticky &&
                    this.section.querySelector("[data-form-wrapper]")) ||
                this.form),
                (this.image = this.querySelector("[data-cart-bar-image]")),
                (this.options = this.querySelector("[data-cart-bar-options]")),
                (this.qty = this.querySelector("[data-cart-bar-qty]")),
                (this.atcBtn = this.querySelector("[data-cart-bar-add-to-cart]")),
                this.addEventListener("click", this.boundHandleClick),
                ["theme:cart:refresh", "theme:cart-bar:reset-atc-animation"].forEach((t) =>
                    document.addEventListener(t, this.boundResetATC)
                ),
                this.initOptions(),
                this.initQty(),
                this.subVariant(),
                this.initObserver();
        }

        resetATC() {
            this.atcBtn?.classList.remove("is-loading"), this.atcBtn?.removeAttribute("disabled");
        }

        handleClick(t) {
            if (t.target.closest("[data-scroll-to-form]")) {
                t.preventDefault();
                const e = this.section.querySelector("product-form");
                if (!e) return;
                return (
                    e.setAttribute("tabindex", "-1"),
                    e.focus({ preventScroll: !0 }),
                    void e.scrollIntoView({ behavior: "smooth", block: "start" })
                );
            }

            if (t.target.closest("[data-cart-bar-add-to-cart]")) {
                t.preventDefault();
                const e = this.form.querySelector("[data-add-to-cart]");
                if (!e || e.hasAttribute("disabled")) return;

                this.atcBtn.classList.add("is-loading"),
                    this.atcBtn.setAttribute("disabled", !0),
                    this.form.requestSubmit ? this.form.requestSubmit(e) : e.click();
            }
        }

        initOptions() {
            this.options
                ?.querySelectorAll("[data-popout-input]")
                .forEach((t) => t.addEventListener("change", this.boundOptionChange));
        }

        handleOptionChange(t) {
            const e = t.target.getAttribute("data-option-value-id");
            if (!e) return;

            const i = this.section?.querySelector("product-form variant-selects"),
                s = i?.querySelector(`[data-option-value-id="${CSS.escape(e)}"]`);
            if (!s) return;

            const r = new MouseEvent("click", { bubbles: !0, cancelable: !0 });
            if (((r.fromCartBar = !0), "A" === s.tagName || s.matches("input"))) {
                if ((s.dispatchEvent(r), s.matches("input"))) {
                    const t = new Event("change", { bubbles: !0 });
                    (t.fromCartBar = !0), s.dispatchEvent(t);
                }
            } else {
                const t = s.querySelector(".select-popout__option");
                t ? t.dispatchEvent(r) : s.closest('label, a, [role="button"]')?.dispatchEvent(r);
            }
        }

        subVariant() {
            window.subscribe &&
                window.theme?.PUB_SUB_EVENTS?.variantChange &&
                (this.unsub = window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, ({ data: t }) => {
                    const e = t?.sectionId;
                    !e ||
                        (e !== this.section.dataset.section && e !== this.section.dataset.originalSection) ||
                        (this.updateImage(t.variant),
                        this.updateOptions(t.variant),
                        this.updateBtn(t.variant),
                        this.updatePrice(t.variant));
                }));
        }

        updateImage(t) {
            const e = this.image?.querySelector("img"),
                i = t?.featured_media?.preview_image?.src;
            e && i && (e.src = `${i}${i.includes("?") ? "&" : "?"}width=160`);
        }

        updateOptions(t) {
            if (!this.options || !t?.options) return;

            const e = this.section?.querySelector("product-form variant-selects");
            if (!e) return;

            this.options.querySelectorAll("popout-select").forEach((i) => {
                const s = i.querySelector("[data-popout-input]"),
                    r = parseInt(s?.dataset.index?.replace("option", "") || "", 10);
                if (!s || isNaN(r)) return;

                const a = t.options[r - 1],
                    o = i.querySelector("[data-popout-text]");

                i.querySelectorAll("[data-popout-option]").forEach((t) => {
                    const r = t.dataset.value,
                        n = r === a,
                        c = t.closest("li");

                    if (n && c) {
                        o && (o.textContent = r),
                            (s.value = r),
                            c.dataset.optionValueId && s.setAttribute("data-option-value-id", c.dataset.optionValueId),
                            c.dataset.productUrl && s.setAttribute("data-product-url", c.dataset.productUrl),
                            i
                                .querySelector(".select-popout__item--current")
                                ?.classList.remove("select-popout__item--current"),
                            c.classList.add("select-popout__item--current"),
                            i.querySelector('[aria-current="true"]')?.removeAttribute("aria-current"),
                            t.setAttribute("aria-current", "true");
                    }

                    const l = c?.dataset.optionValueId;
                    if (l) {
                        const i = e.querySelector(`[data-option-value-id="${CSS.escape(l)}"]`);
                        if (i) {
                            const e =
                                i.closest(".sold-out, .unavailable") ||
                                i.classList.contains("unavailable") ||
                                i.disabled ||
                                i.querySelector(".sold-out, .unavailable");
                            t.classList.toggle("unavailable", !!e);
                        }
                    }
                });
            });
        }

        updateBtn(t) {
            const e = this.atcBtn,
                i = this.querySelector("[data-add-to-cart-text]");
            if (!e || !i || !t) return;

            const s = t.available;
            (i.textContent = window.theme?.strings?.[s ? "addToCart" : "soldOut"] || (s ? "Add to cart" : "Sold out")),
                e.toggleAttribute("disabled", !s);
        }

        updatePrice(t) {
            const e = this.querySelector("[data-product-price]");
            if (!e || !t) return;

            const i = (t) =>
                window.theme.formatMoney(
                    t,
                    window.theme?.settings?.currency_code_enable
                        ? window.theme.moneyWithCurrencyFormat
                        : window.theme.moneyFormat
                );

            e.innerHTML = 0 === t.price ? window.theme?.strings?.free || "Free" : i(t.price);

            const s = t.compare_at_price > t.price;
            e.classList.toggle("product__price--sale", s);

            const r = this.querySelector(".product__price--strike");
            r && ((r.textContent = s ? i(t.compare_at_price) : ""), r.classList.toggle("hidden", !s));
        }

        initQty() {
            if (!this.qty) return;

            const t = this.qty.querySelector("[data-quantity-field]"),
                e = Array.from(this.section.querySelectorAll("[data-quantity-holder]"))
                    .find((t) => !this.contains(t))
                    ?.querySelector("[data-quantity-field]");

            if (!t || !e) return;

            (t.value = e.value), (this.qtySync = !1);

            const i = (t, e) => {
                this.qtySync ||
                    ((this.qtySync = !0),
                    (e.value = t.value),
                    e.dispatchEvent(new Event("change", { bubbles: !0 })),
                    (this.qtySync = !1));
            };

            (this.syncMain = () => i(e, t)),
                (this.syncBar = () => i(t, e)),
                [e, t].forEach((t) =>
                    ["input", "change"].forEach((i) => t.addEventListener(i, t === e ? this.syncMain : this.syncBar))
                ),
                (this.mainQtyRef = e),
                (this.barQtyRef = t);
        }

        initObserver() {
            "IntersectionObserver" in window && this.formWrapper
                ? ((this.obs = new IntersectionObserver(
                      (t) => {
                          t.forEach((t) =>
                              this.classList.toggle("is-visible", !t.isIntersecting && t.boundingClientRect.top < 0)
                          );
                      },
                      { rootMargin: "0px", threshold: 0 }
                  )),
                  this.obs.observe(this.formWrapper))
                : document.addEventListener("theme:scroll", this.boundScroll);
        }

        toggleScroll() {
            this.formWrapper &&
                this.classList.toggle(
                    "is-visible",
                    window.scrollY > this.formWrapper.offsetTop + this.formWrapper.offsetHeight
                );
        }

        disconnectedCallback() {
            ["theme:cart:refresh", "theme:cart-bar:reset-atc-animation"].forEach((t) =>
                document.removeEventListener(t, this.boundResetATC)
            ),
                this.obs ? this.obs.disconnect() : document.removeEventListener("theme:scroll", this.boundScroll),
                this.unsub?.(),
                this.removeEventListener("click", this.boundHandleClick),
                this.options
                    ?.querySelectorAll("[data-popout-input]")
                    .forEach((t) => t.removeEventListener("change", this.boundOptionChange)),
                this.mainQtyRef &&
                    ["input", "change"].forEach((t) => this.mainQtyRef.removeEventListener(t, this.syncMain)),
                this.barQtyRef &&
                    ["input", "change"].forEach((t) => this.barQtyRef.removeEventListener(t, this.syncBar));
        }
    }

    customElements.get("cart-bar") || customElements.define("cart-bar", t);
})();